"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aiPromptCreateApi = aiPromptCreateApi;
exports.aiPromptDeleteApi = aiPromptDeleteApi;
exports.aiPromptDetailApi = aiPromptDetailApi;
exports.aiPromptListApi = aiPromptListApi;
exports.aiPromptStatusChangeApi = aiPromptStatusChangeApi;
exports.aiPromptUpdateApi = aiPromptUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * AI提示词列表
 * @param params
 */
function aiPromptListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/aiPrompt/list',
    method: 'GET',
    params: params
  });
}

/**
 * 删除AI提示词
 * @param data
 */
function aiPromptDeleteApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/aiPrompt/delete',
    method: 'POST',
    data: data
  });
}

/**
 * 设置AI提示词状态
 * @param data
 */
function aiPromptStatusChangeApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/aiPrompt/toggle-status',
    method: 'POST',
    data: data
  });
}

/**
 * 新增AI提示词
 * @param data
 */
function aiPromptCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/aiPrompt/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑AI提示词
 * @param data
 */
function aiPromptUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/aiPrompt/update',
    method: 'POST',
    data: data
  });
}

/**
 * 商品AI提示词
 * @param id
 */
function aiPromptDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/aiPrompt/detail/".concat(id),
    method: 'GET'
  });
}